export enum SortOptions {
  // If the sort options are not specified, we will pick the sorting options based on TDR specific conditions.
  // e.g: https://aboutyou.atlassian.net/wiki/spaces/CSI/pages/2194735155/Tech+Requirements will decided base on an A/B
  // if to pick SORT_OPTIONS_TOP_SELLER or SORT_OPTIONS_PERSONALISED
  UNSPECIFIED = 0,
  // Sorts the products by their absolute reduction amount
  HIGHEST_REDUCTION = 1,
  // Sorts the products based on their price in an descending order
  HIGHEST_PRICE = 2,
  // Sorts the products based on their price in an ascending order
  LOWEST_PRICE = 3,
  // Sorts the newest products on top
  MOST_RECENT = 4,
  TOP_SELLER = 5,
  PERSONALISED = 6,
}
